export const MAX_SCREEN_WIDTH = 2500;
